
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-auth-dialog',
  templateUrl: './auth-dialog.component.html',
  styleUrls: ['./auth-dialog.component.scss']
})
export class AuthDialogComponent {
  selectedIndex = 0;

  constructor(
    private dialogRef: MatDialogRef<AuthDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Set tab based on incoming data
    if (data?.tab === 'register') {
      this.selectedIndex = 1;   // Register tab
    } else {
      this.selectedIndex = 0;   // Login tab
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
